import type { FC } from 'react';

import { Dialog as HeadlessDialog } from '@headlessui/react';
import cn from 'classnames';

import useIsMobile from '~/hooks/useIsMobile';
import { communityImageSrc } from '~/routes/community/_utils/communityImageSrc';

interface ModalBrandHeaderProps {
  imageUrl?: string;
  imageAlt: string;
  title: string;
  description?: string;
  className?: string;
}

// Shared top block of the community modals (auth + upgrade)
export const ModalBrandHeader: FC<ModalBrandHeaderProps> = ({ imageUrl, imageAlt, title, description, className }) => {
  const isMobile = useIsMobile();

  return (
    <div className={cn('flex w-full flex-col items-center gap-8', className)}>
      {imageUrl && (
        <img src={communityImageSrc(imageUrl, 128)} alt={imageAlt} className="h-16 w-auto rounded-md object-contain" />
      )}

      <div className="flex w-full flex-col items-center gap-[11px] text-center">
        <HeadlessDialog.Title
          as="h2"
          className={cn('font-semibold text-black', {
            'text-2xl leading-7': isMobile,
            'text-[28px] leading-8 tracking-[-0.56px]': !isMobile,
          })}
        >
          {title}
        </HeadlessDialog.Title>

        {description && <p className="whitespace-pre-line text-[15px] leading-5 text-black/50">{description}</p>}
      </div>
    </div>
  );
};
